import { Controller } from '@hotwired/stimulus';

export default class CertificateTypesSelection extends Controller {
  static targets = [
    'totalQuantity',
    'quantity',
    'englishName',
    'submit'
  ];

  connect() {
    this.update();
  }

  update() {
    const quantities = this.quantityTargets.filter(quantity => Number(quantity.value) > 0);

    const totalQuantity = quantities.reduce((acc, quantity) => {
      return acc + Number(quantity.value);
    }, 0);

    const needEnglishName = quantities.some(quantity => {
      return quantity.dataset.needEnglishName === 'true';
    });

    this.englishNameTarget.disabled      = !needEnglishName;
    this.submitTarget.disabled           = totalQuantity === 0;
    this.totalQuantityTarget.textContent = totalQuantity;
  }
}
